import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import styles from './Navbar.module.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const logoSrc = '/images/others/logo.png';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
      <div className={styles.inner}>
        <Link 
          to="/" 
          className={styles.brand} 
          aria-label="TSIL home"
          onClick={() => setOpen(false)}
        >
          <img src={logoSrc} alt="TSIL logo" className={styles.logoImg} />
          <span className={styles.logoText}>TSIL</span>
        </Link>

        {/* Semi-transparent blur backdrop overlay behind floating drawer */}
        <div 
          className={`${styles.backdrop} ${open ? styles.backdropOpen : ''}`} 
          onClick={() => setOpen(false)}
        />

        <nav className={`${styles.links} ${open ? styles.open : ''}`}>
          {[
            { to: '/services', label: 'Services' },
            { to: '/projects', label: 'Projects' },
            { to: '/about', label: 'About' },
            { to: '/contact-us', label: 'Contact Us' },
          ].map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `${styles.link} ${isActive ? styles.active : ''}`
              }
              onClick={() => setOpen(false)}
            >
              {label}
            </NavLink>
          ))}
        </nav>

        <button
          className={`${styles.burger} ${open ? styles.open : ''}`}
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}
